export const exceptionModal = {
  exceptionModal: {
    exceptionModalTitle: "Opa! Tivemos um problema.",
    exceptionModalSubtitle:
      "Por alguma razão não conseguimos recriar seu plano, mas já estamos trabalhando no problema e logo ele será corrigido.",
    exceptionModalButton: "Ok. Aguardo a correção.",
  },
};
